import * as React from 'react';
import { IImage } from './models/IImage';
import ImageGallery from 'react-image-gallery';

export interface IAppProps {
  images: IImage[];
}


export default class App extends React.Component<IAppProps, {}> {
  public render(): React.ReactElement<{}> {
    return (
      <ImageGallery
        items={this.props.images.map(img => {
          return {
            original: `images/${img.url}`,
            thumbnail: `images/${img.url}`,
            description: img.desc,
            originalClass: "test"
          }
        })}
      />
    );
  }
}